import Vue from 'vue';

export function errorAlert(vm, message) {
    window.alert(message);
}
